import { render, staticRenderFns } from "./OrderTD1.vue?vue&type=template&id=6c2af48d&scoped=true&"
import script from "./OrderTD1.vue?vue&type=script&lang=js&"
export * from "./OrderTD1.vue?vue&type=script&lang=js&"
import style0 from "./OrderTD1.vue?vue&type=style&index=0&lang=less&"
import style1 from "./OrderTD1.vue?vue&type=style&index=1&id=6c2af48d&lang=less&scoped=scoped&"
import style2 from "./OrderTD1.vue?vue&type=style&index=2&id=6c2af48d&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2af48d",
  null
  
)

export default component.exports